<script setup lang="ts">
import { Card, Icon } from '@skillstown/leap';
import { useUserSidebar } from '~~/stores/userSidebar';
const sidebarStore = useUserSidebar();

</script>

<template>
  <div class="layout">
    <header class="layout__header">
      <div class="header__wrapper">
        <div class="header__left">
          <button type="button" class="menu-toggle" @click="sidebarStore.toggleSidebar">
            <Icon icon="text" />
          </button>
          <NuxtLink to="/dashboard" class="logo hidden lg:block">
            <img src="@/assets/images/nibe-logo.svg" width="80" />
          </NuxtLink>
        </div>
        <NavigationUser />
      </div>
    </header>
    <main class="c-main">
      <slot></slot>
    </main>
    <div :class="[
      'layout__navigation-backdrop',
      sidebarStore.isSidebarOpen ? 'layout__navigation-backdrop--visible' : 'layout__navigation-backdrop--hidden',
    ]" @click="sidebarStore.closeSidebar"></div>
  </div>
</template>
<style lang="postcss" scoped>
.layout__navigation-backdrop--visible {
  @apply opacity-100 pointer-events-auto;
  position: fixed;
  inset: 0;
  z-index: 40;
  @apply bg-black bg-opacity-40;
  @apply transition-opacity duration-200 ease-out;
  @apply lg:hidden;
}

.layout__navigation-backdrop--hidden {
  @apply opacity-0 pointer-events-none;
  @apply lg:hidden;
}

.layout__header {
  @apply w-full;
  @apply h-[77px];
  @apply flex items-center justify-center;
  @apply bg-white;
  @apply border-b border-gray-300 border-opacity-70;
  @apply rounded-b-[16px];

  .header__wrapper {
    @apply flex w-full justify-between p-2 px-6;
  }

  .header__left {
    @apply flex items-center gap-3;
  }

  .menu-toggle {
    @apply inline-flex items-center justify-center;
    @apply h-10 w-10 rounded-full border border-gray-300;
  }

  @media (min-width: 1024px) {
    .menu-toggle {
      display: none;
    }
  }
}
</style>